import { Box, CircularProgress, Container, Grid, Paper, styled } from '@mui/material';
import React, { Component } from 'react'
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import Constantes from '../php/Constantes';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));


const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

class MontoRetroactivo extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            notificaciones: null,
            errores: null,
            retroactivo: '',
            consultaRealizada: false,
            pdf: '',
            pdfConvenio: '',

            archivosObligatorios: {
                acuerdoFirmado: '',
                firmaAcuerdo: '0',
            },

            retroactivoCargado: '',
        }

        this.manejarCambiosDatosAcuerdo = this.manejarCambiosDatosAcuerdo.bind(this);
        this.manejarEnvioAcuerdo = this.manejarEnvioAcuerdo.bind(this);
    }

    async componentDidMount(){
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario]);

        const control = await fetch(`${Constantes.RUTA_API}/obtener_retroactivo.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();
        this.setState({
            errores: res[0],
            loading: false,
        });
        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: null,
                retroactivo: res[1],
                consultaRealizada: true,
                pdf: res[2],
                pdfConvenio: res[4],
                retroactivoCargado: res[3],
            });
        }
    }
    render(){
        return (
            <>
                {sessionStorage.login
                ?
                    null
                :
                    <Redirect to='/calmette-app/login'/>
                }
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                {(this.state.consultaRealizada) && (this.state.retroactivo !== 0)
                ?
                    <Container style={{marginTop: '1rem'}}>
                        <Box sx={{ flexGrow: 1}} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={2}>
                                    <Item>Estado:</Item>
                                </Grid>
                                <Grid item xs={4} style={{textAlign: 'left'}}>
                                    {this.state.retroactivoCargado.estado === 0
                                    ?
                                        <p style={{color: 'red'}}>Pendiente</p>
                                    :
                                        this.state.retroactivoCargado.estado === 1
                                        ?
                                            <p style={{color: 'red'}}>Acuerdo aceptado y enviado</p>
                                        :
                                            this.state.retroactivoCargado.estado === 2
                                            ?
                                                <p style={{color: 'red'}}>Acuerdo aceptado y confirmado por RRHH</p>
                                            :
                                                this.state.retroactivoCargado.estado === 3
                                                ?
                                                    <p style={{color: 'red'}}>Acuerdo firmado y rechazado por RRHH</p>
                                                :
                                                    this.state.retroactivoCargado.estado === 4 
                                                    ?
                                                        <p style={{color: 'red'}}>Acuerdo transaccional no aceptado</p>
                                                    :
                                                        null
                                    }
                                </Grid>
                                <Grid item xs={2}>
                                </Grid>
                                {this.state.retroactivoCargado.estado === 3
                                ?
                                    <>
                                        <Grid item xs={4}>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Item>Motivo Rechazo:</Item>
                                        </Grid>
                                        <Grid item xs={6} style={{textAlign: 'left'}}>
                                            {this.state.retroactivoCargado.motivoRechazo}
                                        </Grid>
                                    </>
                                :
                                    null
                                }
                            </Grid>
                        </Box>
                        <Box sx={{ flexGrow: 1}} style={{marginTop: '2rem'}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>
                                </Grid>
                                <Grid item xs={5}>
                                    <Item>Por todo concepto de regularización, el monto adeudado es:</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <h4>{'$ ' + this.state.retroactivo}</h4>
                                </Grid>
                            </Grid>
                        </Box>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-primary btn-sm mx-2" onClick={() => handleDownloadPdf('acuerdo', this.state.pdf.acuerdo)}>Descargar Acuerdo</button>
                        <button style={{marginTop: '1rem'}} className="btn btn-outline-primary btn-sm mx-2" onClick={() => handleDownloadPdf('convenio', this.state.pdfConvenio.acuerdo)}>Descargar Convenio</button>
                        <Box sx={{ flexGrow: 1}} style={{marginTop: '2rem'}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={3}>
                                    <Item>¿Acepta acuerdo transaccional?</Item>
                                </Grid>
                                <Grid item xs={2}>
                                    <select style={{width:"100%", border:"2px solid #D6EAF8", textAlign: 'center'}} id='firmaAcuerdo' value={this.state.archivosObligatorios.firmaAcuerdo} onChange={this.manejarCambiosDatosAcuerdo} >
                                        <option value={false}></option>
                                        <option key={1} value={1}>SI</option>
                                        <option key={2} value={2}>NO</option>
                                    </select>
                                </Grid>
                            </Grid>
                        </Box>
                        {this.state.archivosObligatorios.firmaAcuerdo === '1'
                        ?
                            <>
                                <Box sx={{ flexGrow: 1}} style={{marginTop: '2rem'}}>
                                    <Grid container spacing={2} rowSpacing={1}>
                                        <Grid item xs={2}>
                                        </Grid>
                                        <Grid item xs={3}>
                                            <Item>Cargar Acuerdo Firmado (PDF):</Item>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <input type="file" style={{border: "2px solid #D6EAF8", width: "100%"}} id='acuerdoFirmado' onChange={this.manejarCambiosDatosAcuerdo} accept=".pdf"/>
                                        </Grid>
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioAcuerdo}>Enviar</button>
                                        </Grid>
                                    </Grid>
                                </Box>
                                <br/>
                                <br/>
                            </>
                        :
                            this.state.archivosObligatorios.firmaAcuerdo === '2'
                            ?
                                <>
                                    <button className="btn btn-outline-primary mx-2" type='button' onClick={this.manejarEnvioAcuerdo}>Enviar</button>
                                    <br/>
                                    <br/>
                                </>
                            :
                                null
                        }
                    </Container>
                :
                    null
                }
            </>
        )
    }

    async manejarCambiosDatosAcuerdo(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor;
        if(clave === 'acuerdoFirmado'){
            valor = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = (e) => {
                e.preventDefault();
                this.setState(state => {
                    const movimientosActualizado = state.archivosObligatorios;
                    movimientosActualizado[clave] = e.target.result;
                    return{
                        archivosObligatorios: movimientosActualizado,
                    };
                });
            };
        }else{
            let valor = e.target.value;
            this.setState(state => {
                const movimientosActualizado = state.archivosObligatorios;
                movimientosActualizado[clave] = valor;
                return{
                    archivosObligatorios: movimientosActualizado,
                };
            })
        }
    }

    async manejarEnvioAcuerdo(e){
        e.preventDefault();
        this.setState({
            loading: true,
        });
        const cargaUtil = JSON.stringify([sessionStorage.numeroFuncionario, this.state.archivosObligatorios]);

        const control = await fetch(`${Constantes.RUTA_API}/cargar_acuerdoFirmado.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const res = await control.json();

        this.setState({
            loading: false,
            errores: res[0],
            notificaciones: null,
        })

        if(res[0] === 'ok'){
            this.setState({
                errores: null,
                notificaciones: 'Datos Ingresados correctamente',
            })
        }
    }
}

export default MontoRetroactivo